import { pipe } from 'ramda';
import { RootState } from '../index';

const selectHeurekaState = ({ heureka }: RootState) => heureka;

export const selectHeurekaPatient = pipe(selectHeurekaState, ({ heurekaPatients }) => heurekaPatients);

export const selectMedications = pipe(selectHeurekaState, ({ medications }) => medications);
